import type { AthleteCalendarItem } from './types';

export const hasWorkout = (items: AthleteCalendarItem[] = []): boolean =>
  items.some(item => item.kind === 'workout');
